import { id } from "date-fns/locale";

export const handlePrint = () => {
    window.print();
};

export const handleDownloadCSV = (data, filename, machineId = "") => {
    if (!Array.isArray(data) || data.length === 0) {
        alert("No hay datos para exportar.");
        console.log("🚨 No hay datos en la tabla seleccionada:", data);
        return;
    }

    console.log("✅ Datos exportados:", data); // Verifica si hay datos antes de exportar

    let csvContent = "data:text/csv;charset=utf-8,";

    if (filename === "activities_report") {
        csvContent += "Machine,Activities/Day,Date\n";






        //v1
        data.forEach((row) => {
            const fecha = new Date(row.fecha).toLocaleDateString("es-ES", { day: "2-digit", month: "2-digit", year: "numeric" });
            csvContent += `${row.cod_maq},${row.actividad},${fecha}\n`;
        });
    } else if (filename === "averages_report") {
        csvContent += "Date,Hour,First Record,Last Record,Total Records,Average Records/Hour\n";
        data.forEach((row) => {
            const fecha = new Date(row.fecha).toLocaleDateString("es-ES", { day: "2-digit", month: "2-digit", year: "numeric" });
            const primerReg = new Date(row.primer_reg).toLocaleString("es-ES");
            const ultimoReg = new Date(row.ultimo_reg).toLocaleString("es-ES");

            const promedioHoras = Number(row.promedio_horas) || 0; // Asegura que sea un número antes de toFixed()

            csvContent += `${fecha},${row.hora}:00,${primerReg},${ultimoReg},${row.total_registros},${promedioHoras.toFixed(2)}\n`;
        });




    } else {
        alert("Error: Tipo de archivo no reconocido.");
        return;
    }

    // Generar y descargar el archivo CSV con el nombre dinámico
    const fileNameWithMachineId = machineId ? `${filename}_${machineId}.csv` : `${filename}.csv`;
    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", fileNameWithMachineId);
    document.body.appendChild(link);
    link.click();
};
